module.exports = __webpack_public_path__ + "media/images/pen-a6cce8cd15094478cd388c7f956da4f1.svg";